import React from "react";
import { motion } from "framer-motion";
import { Building2, Users, ShieldCheck, Star } from "lucide-react";

const stats = [
  { icon: Building2, value: "560+", label: "Nursing Homes Listed" },
  { icon: Users, value: "10,000+", label: "Families Helped" },
  { icon: ShieldCheck, value: "100%", label: "Free & Independent" },
  { icon: Star, value: "4.9/5", label: "Family Rating" },
];

export default function TrustBar() {
  return (
    <section className="py-10 bg-card border-y border-border">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="flex flex-col items-center text-center gap-2"
            >
              <stat.icon className="h-6 w-6 text-primary mb-1" />
              <p className="text-2xl md:text-3xl font-bold text-foreground font-lora">
                {stat.value}
              </p>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
